// 导入支付API
import { payment } from '@/api/checkout';
// 导入工具函数
import { getBrowerInfo, getCardExpiredFullYear, paymentFields, billingFields } from '@/utils/tools/utils';

// 导入GA事件函数
import { sendGaEvent } from './ga';
import { CHECKOUT_STATUS, exceptionShow, CheckoutException } from '../config';
/**
 * 获取支付数据
 * @param {Object} form 表单数据
 * @param {String} key 订单key
 * @param {Array} fieldConfigurationNames 字段配置名称
 * @param {Object} instalmentInfo 分期信息
 * @returns {Object} 支付数据对象
 */
export function getPaymentData(form, key, fieldConfigurationNames, instalmentInfo, order) {
  // 获取浏览器信息
  const browerInfo = getBrowerInfo();

  // 初始化提交数据对象
  const cardInfo = order?.cardInfo || {};

  const submitData = {
    ...form,
    key,
    // 处理卡号，移除所有空格
    cardNumber: form?.cardNum?.replace(/\s*/g, ''),
    // 获取有效期的月份
    month: form?.effectiveDate?.split('/')[0]?.trim(),
    // 获取卡到期的完整年份
    year: getCardExpiredFullYear(form?.effectiveDate?.split('/')[1]?.trim()),
    // 处理持卡人姓名并移除两端空格
    holderName: form?.cardHolderName?.trim() || cardInfo?.holderName?.trim(),
    // 使用订单key作为会话ID
    sessionId: key,
    // 获取页面引荐来源
    referer: window.document.referrer,
    // 重试提交标识
    transSceneFlag: order.retry === '1' ? '1' : undefined,
    birthDate: form?.birthDate?.replace(/\s*/g, ''),
    // 合并浏览器信息
    ...browerInfo,
  };

  // 如果存在分期值，添加分期相关信息
  if (form.periodValue) {
    // 设置分期期数
    submitData.periodValue = form.periodValue;
    // 如果是DLOCAL支付机构的分期
    if (instalmentInfo && instalmentInfo.institution === 'DLOCAL') {
      // 遍历所有可用分期阶段
      for (let i = 0; i < instalmentInfo.stages.length; i++) {
        // 获取当前分期阶段
        const stage = instalmentInfo.stages[i];
        // 匹配选择的分期期数
        if (stage.stageNumber === form.periodValue) {
          // 设置分期计划ID
          submitData.installmentPlanId = stage.installmentPlanId;
          break;
        }
      }
    }
  }

  // 设置国家字段
  submitData.country = form.country;
  // 处理身份证号
  if (submitData.identityNumber) {
    // 移除身份证号两侧空格
    submitData.identityNumber = submitData.identityNumber.trim();
    // 如果是巴西，则移除身份证号中的非数字字符
    if (submitData.country === 'BR') {
      submitData.identityNumber = submitData.identityNumber.replace(/[^\d]/g, '');
    }
  }
  // 返回组装好的提交数据
  return submitData;
}

/**
 * 提交支付
 * @param {Object} options 所有需要的选项和回调
 */
export async function submitPayment(options) {
  // 解构需要的参数
  const {
    formRef,
    form,
    fieldConfigurationNames,
    instalmentInfo,
    key,
    router,
    order,
    setFullscreenLoading,
    gaOptions,
    onRetry,
    trackingCallBack,
  } = options;

  // 验证表单
  // 发送点击支付按钮事件
  sendGaEvent(order, 'click_payment_button', '', form, gaOptions);
  // 发送点击结果事件，记录验证成功或失败
  // TODO
  sendGaEvent(order, 'click_result', '', form, gaOptions, { result: 'S' });

  // 如果验证通过
  // 显示全屏加载中
  setFullscreenLoading(true);
  // 获取支付数据

  const data = getPaymentData(form, key, fieldConfigurationNames, instalmentInfo, order);

  // 调用支付API
  const res = await payment(data).catch(() => {
    // TODO 是不是ERROR好一些
    throw new CheckoutException({
      status: CHECKOUT_STATUS.PENDING,
      // message: res.respMsg,
    });
  });
  trackingCallBack({ e: 'payment_result' });

  try {
    // 发送支付结果事件
    sendGaEvent(order, 'payment_result', '', form, gaOptions, {
      result: res.data && res.data.status ? res.data.status : 'F',
      result_desc: res.respMsg,
    });
  } catch (err) { }

  // 重试
  if (res?.data?.retry === '1') {
    onRetry(res?.data);
    setFullscreenLoading(false);
    return;
  }

  // 处理接口返回成功的情况
  if (res.respCode === '20000') {
    // 处理失败状态
    if (res.data.status === 'F') {
      throw new CheckoutException({
        status: CHECKOUT_STATUS.FAILED,
        message: res.data.reason || res.respMsg,
        others: res.data,
      });
    } else if (res.data.status === 'S') { // 处理成功状态
      throw new CheckoutException({
        status: CHECKOUT_STATUS.SUCCESS,
      });
    } else if (res.data.status === 'P') { // 处理待处理状态
      throw new CheckoutException({
        status: CHECKOUT_STATUS.PENDING,

      });
    } else if (res.data.status === 'R') { // 处理重定向状态
      window.location.href = res.data.redirectUrl;
    }
  } else {
    // 处理接口返回失败的情况
    // 尝试显示异常信息，如果不能处理则跳转到失败页面
    if (!exceptionShow(res)) {
      throw new CheckoutException({
        status: CHECKOUT_STATUS.FAILED,
        message: res?.respMsg || res?.data?.reason,
        others: res?.data,
      });
    }
  }
}
